import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "app/_services";
import { GenericService } from "app/_services/generic.service";
import { environment } from "environments/environment";

@Injectable({
    providedIn: 'root'
  })
  export class RoleService extends GenericService<any> {

    private bearerToken: string = "";

    constructor(private http: HttpClient,
        private authService: AuthService) {
        super(http, '/api/AuthorizationGroupRole',environment.Services.MasterDataURL)
        this.bearerToken = authService.getToken();
    }

    private createHeaders(): Object {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + this.bearerToken);
        return headers;
    }

    getAuthorizationRoles(){
        let url = environment.apiProtocol + environment.Services.MasterDataURL + "/api/AuthorizationRole/GetAll";
        return this.http.get(
          url,
          this.createHeaders()
          );
      }

    getAuthorizationRolesInheritance(){
        let url = environment.apiProtocol + environment.Services.MasterDataURL + "/api/AuthorizationGroupRole/GetInheritances";
        return this.http.get(
          url,
          );
      }

    addRoleGroup(roleGroup){
        let url = environment.apiProtocol + environment.Services.MasterDataURL + "/api/AuthorizationGroupRole/Post";
        return this.http
            .post( url ,roleGroup );
    }

    updateRoleGroup(roleGroup){
        let url = environment.apiProtocol + environment.Services.MasterDataURL + "/api/AuthorizationGroupRole/Put";
        return this.http
            .put( url ,roleGroup );
    }
}